<template lang="pug">
  bDropSelector(
    :options="['Inherit', 'Break', 'Ellipsis', 'Hidden', 'Visible']"
    :value="value"
    @change="$emit('change', $event)"
  )
</template>

<script>
export default {
  name: "lineBrakEditor",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: "start"
    }
  }
};
</script>
